import React from 'react';

function InfoSection({ heading, grade, tags, link }) {
  return (
    <div className = 'infosection'>
      <div className="info">
        {/* <h3 href className="heading">{heading}</h3> */}
        <h3 className="heading">
          <a href={link} target="_blank" rel="noopener noreferrer">
            {heading}
            <svg className="external-link-arrow" viewBox="0 0 12 12" aria-hidden="true">
              <path d="M3 9 9 3M4 3h5v5" />
            </svg>
          </a>
        </h3>
        <h3 className="grade">{grade}</h3>
      </div>
      <div className="tags">
        <h3 className="tag">
          {tags.split(',').map((tag) => (
            <span className="tag-item" key={tag.trim()}>{tag.trim()}</span>
          ))}
        </h3>
      </div>
    </div>
  );
}

export default InfoSection;
